<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'UserDetailsAdministratorForm',
  props: {
    validation: Object
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('users', {
      userForm: state => state.userForm,
      addressForm: state => state.addressForm,
      administratorForm: state => state.administratorForm
    })
  },
  methods: {
    ...mapMutations('users', [
      'updateUserForm',
      'updateAddressForm',
      'updateAdministratorForm'
    ]),
    ...mapMutations([
      'closeDetails'
    ])
  }
}
</script>

<template>
  <div class="fit">
  </div>
</template>

<style>
</style>
